import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "autocomplete-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "autocomplete-selected form-control d-flex align-items-center justify-content-between"
}
const _hoisted_3 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_4 = {
  key: 0,
  class: "autocomplete-dropdown"
}
const _hoisted_5 = {
  key: 0,
  class: "autocomplete-item text-muted"
}
const _hoisted_6 = ["onMousedown", "onMouseover"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_close = _resolveComponent("icon-close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.localValue && !_ctx.editing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm p-0 me-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
          }, [
            _createVNode(_component_icon_close)
          ]),
          _createElementVNode("div", {
            class: "flex-grow-1",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startEditing && _ctx.startEditing(...args)))
          }, _toDisplayString(_ctx.labelFn ? _ctx.labelFn(_ctx.localValue) : _ctx.localValue), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            ref: "searchInput",
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchText) = $event)),
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
            onKeydown: [
              _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.moveDown && _ctx.moveDown(...args)), ["prevent"]), ["down"])),
              _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.moveUp && _ctx.moveUp(...args)), ["prevent"]), ["up"])),
              _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.selectHighlighted && _ctx.selectHighlighted(...args)), ["prevent"]), ["enter"])),
              _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)), ["esc"]))
            ],
            onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchText]
          ]),
          (_ctx.showDropdown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.items.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Nessun risultato "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: _normalizeClass(["autocomplete-item", { highlighted: i === _ctx.highlightedIndex }]),
                    onMousedown: _withModifiers(($event: any) => (_ctx.selectItem(item)), ["prevent"]),
                    onMouseover: ($event: any) => (_ctx.highlightedIndex = i)
                  }, [
                    _renderSlot(_ctx.$slots, "item", {
                      item: item,
                      highlight: _ctx.highlight
                    }, undefined, true)
                  ], 42, _hoisted_6))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}